<script lang="ts">
    import type * as t from "./types";
    import type { Sequence, SequenceNode } from "./sequence";

    import MultipleChoiceStep from "~/MultipleChoiceStep";
    import EducationalStep from "~/EducationalStep.svelte";
    import SegmentResultStep from "~/SegmentResultStep.svelte";
    import Step from "~/Step.svelte";
    import { getAppContext } from "~/quiz-store";
    import { getRelativeStepIdx } from "~/utils";
    import ConstructMinigameStep from "./ConstructMinigameStep.svelte";
    import NetworkPortalStep from "./NetworkPortalStep.svelte";

    export let segments: Sequence<t.Segment>;
    const { state } = getAppContext();

    function isStepVisible(
        segment: SequenceNode<t.Segment>,
        globalStepIdx: number,
        stepIdx: number,
    ) {
        const relativeStepIdx = getRelativeStepIdx(segments, globalStepIdx);
        return segment === $state.segment && relativeStepIdx >= stepIdx;
    }
</script>

{#each segments.iterate() as segmentNode}
    {#each segmentNode.value.steps.iterate() as stepNode, idx}
        <Step>
            {#if stepNode.value.type === "multiple_choice"}
                <MultipleChoiceStep
                    visible={isStepVisible(
                        segmentNode,
                        $state.globalStepIdx,
                        idx,
                    )}
                    {stepNode}
                />
            {:else if stepNode.value.type === "educational"}
                <EducationalStep
                    settings={stepNode.value}
                    visible={isStepVisible(
                        segmentNode,
                        $state.globalStepIdx,
                        idx,
                    )}
                />
            {:else if stepNode.value.type === "construct_minigame"}
                <ConstructMinigameStep
                    {stepNode}
                    visible={isStepVisible(
                        segmentNode,
                        $state.globalStepIdx,
                        idx,
                    )}
                />
            {:else if stepNode.value.type === "segment_result"}
                <SegmentResultStep
                    {segmentNode}
                    step={stepNode.value}
                    visible={isStepVisible(
                        segmentNode,
                        $state.globalStepIdx,
                        idx,
                    )}
                />
            {:else if stepNode.value.type === "network_portal"}
                <NetworkPortalStep
                    {stepNode}
                    visible={isStepVisible(
                        segmentNode,
                        $state.globalStepIdx,
                        idx,
                    )}
                />
            {/if}
        </Step>
    {/each}
{/each}
